var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBallePerduHand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 100.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #47464b;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #47464b;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.41px;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M103.5,65.14c-15.7,0-28.47-12.77-28.47-28.47s12.77-28.47,28.47-28.47,28.47,12.77,28.47,28.47-12.77,28.47-28.47,28.47ZM103.5,9.03c-15.24,0-27.64,12.4-27.64,27.64s12.4,27.64,27.64,27.64,27.64-12.4,27.64-27.64-12.4-27.64-27.64-27.64Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "93.63 24.09 103.5 29.77 103.5 42.38 94.87 47.79 85 42.38 84.59 30.33 93.63 24.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M94.88,48.27l-10.29-5.63-.43-12.52,9.45-6.51,10.3,5.93v13.08l-9.04,5.66ZM85.41,42.13l9.45,5.17,8.23-5.15v-12.14l-9.43-5.43-8.64,5.96.4,11.59Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "103.29 14.12 97.89 15.36 93.73 24.09 103.5 29.77 113.06 24.09 108.9 15.36 103.29 14.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M103.5,30.25l-10.31-5.99,4.41-9.26,5.69-1.31,5.9,1.31,4.41,9.25-10.1,6ZM94.27,23.93l9.23,5.36,9.02-5.36-3.91-8.2-5.32-1.18-5.12,1.18-3.91,8.2Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "84.36 30.67 79.11 27.18 82.03 17.92 92.48 11.98 98.09 15 97.69 15.73 92.49 12.93 82.72 18.48 80.09 26.83 84.82 29.98 84.36 30.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "79.41 45.9 74.99 36.68 79.22 26.84 79.98 27.17 75.9 36.66 79.78 44.75 84.8 42.02 85.2 42.75 79.41 45.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "92.5 61.15 82.52 55.97 79.2 45.45 80 45.2 83.21 55.39 92.47 60.2 97.67 56.99 98.11 57.7 92.5 61.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M103.29,65.14c-15.7,0-28.47-12.77-28.47-28.47s12.77-28.47,28.47-28.47,28.47,12.77,28.47,28.47-12.77,28.47-28.47,28.47ZM103.29,9.03c-15.24,0-27.64,12.4-27.64,27.64s12.4,27.64,27.64,27.64,27.64-12.4,27.64-27.64-12.4-27.64-27.64-27.64Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "113.26 24.09 103.5 29.77 103.5 42.38 112.04 47.79 121.8 42.38 122.21 30.33 113.26 24.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M112.03,48.27l-8.94-5.66v-13.08l10.2-5.93,9.35,6.52-.42,12.52-10.18,5.64ZM103.92,42.15l8.14,5.15,9.34-5.17.39-11.59-8.54-5.95-9.32,5.42v12.14Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "122.44 30.67 121.98 29.98 126.7 26.83 124.07 18.48 114.3 12.93 109.1 15.73 108.71 15 114.31 11.98 124.76 17.92 127.68 27.18 122.44 30.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "127.38 45.9 121.59 42.75 121.99 42.02 127.01 44.75 130.89 36.66 126.81 27.17 127.58 26.84 131.81 36.68 127.38 45.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "114.29 61.15 108.69 57.7 109.12 56.99 114.33 60.2 123.58 55.39 126.8 45.2 127.59 45.45 124.27 55.97 114.29 61.15"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 109.85,
    y: 61.83,
    width: 5.01,
    height: 0.83,
    transform: "translate(-14.19 84.25) rotate(-38.85)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "97.89 57.21 103.5 58.87 108.9 57.21 112.44 47.79 103.29 42.38 94.98 47.79 97.89 57.21 103.5 58.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M103.5,59.3l-5.95-1.76-3.07-9.93,8.79-5.72,9.67,5.71-3.73,9.94-5.72,1.76ZM98.22,56.87l5.28,1.56,5.09-1.57,3.34-8.9-8.62-5.1-7.83,5.09,2.75,8.91Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M110.22,9.37c7.12,1.22,13.59,7.99,13.59,7.99l.47.7-10.16-5.56-.22-.18-3.68-2.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M125.55,19.23l-11.69-6.4-5.15-4.15,1.58.27c7.17,1.23,13.56,7.83,13.82,8.12l.05.06,1.39,2.1ZM114.36,12.16l7.99,4.37c-1.92-1.73-5.96-4.99-10.43-6.34l2.44,1.97Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96.38,9.37c-7.12,1.22-13.67,8.28-13.67,8.28v.42l9.77-5.56.22-.18,3.68-2.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.3,18.78v-1.29l.11-.12c.27-.29,6.73-7.18,13.9-8.41l1.58-.27-5.2,4.18-10.39,5.91ZM94.68,10.2c-4.41,1.35-8.43,4.67-10.4,6.49l7.96-4.53,2.43-1.96Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M108.72,16l-5.69-1.68-5.33,1.66-5.4-3.47,3.9-3.14s7.84-2.1,14.23,0l3.69,3.14-5.4,3.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M108.78,16.45l-5.75-1.7-5.39,1.68-6.05-3.88,4.42-3.56.08-.02c.32-.09,8.03-2.11,14.47,0l.08.03,4.18,3.56-6.03,3.89ZM103.03,13.88l5.63,1.66,4.77-3.08-3.2-2.73c-5.84-1.89-12.99-.2-13.84.01l-3.38,2.72,4.76,3.05,5.26-1.64Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96.38,63.81c-7.12-1.22-13.59-7.99-13.59-7.99l9.7,4.85.22.18,3.68,2.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.89,64.5l-1.58-.27c-7.17-1.23-13.56-7.83-13.82-8.12l-1.66-1.73,11.91,5.97,5.15,4.15ZM85.27,57.53c2.14,1.8,5.63,4.32,9.42,5.46l-2.44-1.96-6.99-3.5Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M110.22,63.81c7.12-1.22,13.59-7.99,13.59-7.99l-9.7,4.85-.22.18-3.68,2.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M108.72,64.5l5.22-4.19,11.84-5.92-1.66,1.73c-.27.28-6.66,6.88-13.82,8.12l-1.58.27ZM114.35,61.02l-2.44,1.96c3.8-1.14,7.28-3.66,9.42-5.46l-6.99,3.5Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.89,57.19l5.69,1.68,5.33-1.66,5.4,3.47-3.9,3.14s-7.84,2.1-14.23,0l-3.69-3.14,5.4-3.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M102.73,65.17c-2.15,0-4.49-.24-6.68-.96l-.08-.03-4.18-3.56,6.03-3.89,5.75,1.7,5.39-1.68,6.05,3.88-4.42,3.56-.08.02c-.21.06-3.64.96-7.79.96ZM96.38,63.45c5.83,1.89,12.99.2,13.84-.01l3.38-2.72-4.76-3.05-5.26,1.64-5.63-1.66-4.77,3.08,3.2,2.73Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.01,91.99l15.72-11.77c5.3-1.27,10.13-5.41,10.13-5.41,1.85-.47,7.82-4.13,7.82-4.13,1.08-1.31,10.84-3.16,10.84-3.16,7.8.7,6.71-.74,6.71-.74.25-2.44-1.6-2.91-1.6-2.91-5.44-3.31-9.14-1.5-9.14-1.5-5.37,2.48-12.9,1.05-12.9,1.05-10.19-6.07-6.79-17.95-6.79-17.95,1.02-5.3,4.76-15,4.76-15,3.57-8.96.39-9.15.39-9.15-1.66-.57-2.85,2.61-2.85,2.61-1.93,3.79-4.13,8.6-3.78,8.22l1.23-7.36.41-4.03c.72-6.09-2.27-5.63-2.27-5.63-1.96-.3-1.89,1.8-1.89,1.8l-1.2,7.08c-.16,1.59-2.11,8.13-2.11,8.13l.7-7.32c1.39-9.99-.7-9.79-.7-9.79-3.23-.9-3.23,1.52-3.23,1.52-.4,3.92-.69,4.8-.69,4.8-1.28,8.21-2.5,13.75-2.5,13.75l-.21-3.53c.08-10.04-3.34-8.21-3.34-8.21-1.76.26-1.38,2.42-1.38,2.42l.24,6.03c-.82,3.36-.2,10.32-.2,10.32.4,4.44-.51,9.67-.51,9.67-2.2,4.88-3.02,11.51-3.3,14.87-.07.79-.16,1.41-.39,1.95,0,0-4.1,8.36-9.95,10.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.07,35.08s-.38,6.82,0,9.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43.49,32.13s-1.75,9.76-1.75,12.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M49.31,32.16s-4.22,10.66-3.26,12.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M74.51,67.53s-.87-1.87,6.71-.93"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32.26,28.64s3.86,2.31,3.14-4.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40.26,19.79s1.54,1.52,3.97-.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.35,19.55s1.77,2.43,4.68.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.73,25.23s3.89,3.49,4.51-1.63"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBallePerduHand);
export default __webpack_public_path__ + "static/media/balle_perdu_hand.46c44f9644b2f42e5e6f7e926090e2da.svg";
export { ForwardRef as ReactComponent };